import { render, staticRenderFns } from "./PopupChooseProduct.vue?vue&type=template&id=1abf489f&scoped=true&"
import script from "./PopupChooseProduct.vue?vue&type=script&lang=js&"
export * from "./PopupChooseProduct.vue?vue&type=script&lang=js&"
import style0 from "./PopupChooseProduct.vue?vue&type=style&index=0&id=1abf489f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abf489f",
  null
  
)

export default component.exports